import { isSameDay, format } from "date-fns";
import React from "react";
import { EmployeeScheduleRowProps } from "../types/shift-assignment.types"; 
import ShiftCell from "./shift-cell";

const EmployeeScheduleRow: React.FC<EmployeeScheduleRowProps> = ({ 
    employeeSchedule,
    weekDays, 
    shifts: allShifts,
    isLoadingShifts,
    onOpenCreateModal, 
    activePopover, 
    onOpenPopover, 
    onShiftSelect, 
    activeActionMenu, 
    onOpenActionMenu, 
    onRemoveSingle, 
    onRemoveMultiple, 
    rowIndex, 
    totalRows 
}) => {
    const employeeInfo = employeeSchedule.employee;
    const shifts = employeeSchedule.shifts;        

    const openUpwards = rowIndex > totalRows - 5;
    
    const employeeId = employeeInfo.id; 

    return (
        <div className="group contents">
            {/* CỘT 1: THÔNG TIN NHÂN VIÊN */}
            <div className="p-3 flex items-center space-x-3 border-r border-b border-gray-400 bg-white group-hover:bg-gray-100 transition duration-150">
                <div className="text-gray-400">👤</div>
                <div>
                    <p className="font-medium text-gray-900">{employeeInfo.name}</p>
                    <p className="text-sm text-gray-500">{employeeInfo.department_name}</p> 
                </div>
            </div>

            {/* CỘT 2-8: CÁC CA LÀM VIỆC */}
            {weekDays.map((day, index) => {
                const formattedDay = format(day, 'dd/MM/yyyy'); 
                const shift = shifts.find(s => s.date === formattedDay);

                return (
                    <div
                        key={index}
                        className="p-2 h-full border-r border-b border-gray-400 flex items-center justify-center bg-white 
                                   group-hover:bg-gray-100 transition duration-150"
                    >
                        <ShiftCell
                            shift={shift}
                            day={day}
                            employeeId={employeeId}
                            onOpenCreateModal={onOpenCreateModal}
                            shifts={allShifts}
                            isLoadingShifts={isLoadingShifts}

                            isActive={!!(activePopover && isSameDay(activePopover.day, day) && activePopover.employeeId === employeeId)}
                            onOpenPopover={onOpenPopover}
                            onShiftSelect={onShiftSelect}

                            activeActionMenu={activeActionMenu}
                            onOpenActionMenu={onOpenActionMenu}
                            onRemoveSingle={onRemoveSingle}
                            onRemoveMultiple={onRemoveMultiple}
                            openUpwards={openUpwards}
                        />
                    </div>
                );
            })}
        </div>
    );
};

export default React.memo(EmployeeScheduleRow);